import { addInfoData } from "./utils/addInfoData.js";
import { getExtremeValues } from "./utils/getExtremeValues.js";
/**
 * Parse from a xyxy data array
 * @param variables - Variables to convert to jcamp
 * @param [options={}] - options that allows to add meta data in the jcamp
 * @return JCAMP-DX text file corresponding to the variables
 */
export default function creatorNtuples(variables, options) {
    const { meta = {}, info = {} } = options;
    const { title = '', owner = '', origin = '', dataType = '', ...resInfo } = info;
    const symbol = [];
    const varName = [];
    const varType = [];
    const varDim = [];
    const units = [];
    const first = [];
    const last = [];
    const min = [];
    const max = [];
    const keys = Object.keys(variables);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const variable = variables[key];
        if (!variable)
            continue;
        const name = variable?.label.replace(/ *\[.*/, '');
        const unit = variable?.label.replace(/.*\[(?<units>.*)\].*/, '$<units>');
        const { firstLast, minMax } = getExtremeValues(variable.data);
        symbol.push(variable.symbol || key);
        varName.push(name || key);
        varDim.push(variable.data.length);
        first.push(firstLast.first);
        last.push(firstLast.last);
        max.push(minMax.max);
        min.push(minMax.min);
        if (variable.isDependent !== undefined) {
            varType.push(variable.isDependent ? 'DEPENDENT' : 'INDEPENDENT');
        }
        else {
            varType.push(variable.isDependent !== undefined
                ? !variable.isDependent
                : i === 0
                    ? 'INDEPENDENT'
                    : 'DEPENDENT');
        }
        units.push(variable.units || unit || '');
    }
    let header = `##TITLE=${title}
##JCAMP-DX=6.00
##DATA TYPE=${dataType}
##DATA CLASS= NTUPLES
##ORIGIN=${origin}
##OWNER=${owner}\n`;
    header += addInfoData(resInfo, { prefix: '##' });
    header += addInfoData(meta);
    header += `##NTUPLES= ${dataType}
##VAR_NAME=  ${varName.join()}
##SYMBOL=    ${symbol.join()}
##VAR_TYPE=  ${varType.join()}
##VAR_DIM=   ${varDim.join()}
##UNITS=     ${units.join()}
##FIRST=     ${first.join()}
##LAST=      ${last.join()}
##MIN=       ${min.join()}
##MAX=       ${max.join()}
##PAGE= N=1\n`;
    header += `##DATA TABLE= (${symbol.join('')}..${symbol.join('')}), PEAKS\n`;
    for (let i = 0; i < variables.x.data.length; i++) {
        const point = [];
        for (const key of keys) {
            const variable = variables[key];
            if (!variable)
                continue;
            point.push(variable.data[i]);
        }
        header += `${point.join('\t')}\n`;
    }
    header += `##END NTUPLES= ${dataType}\n`;
    header += '##END=\n##END=';
    return header;
}
//# sourceMappingURL=creatorNtuples.js.map